import saveAs from "file-saver";
import { JsonSchema, ColumnOption } from "../../../../types";
import { getSchemaSections } from "../schemaHelpers";
import { Workbook } from "exceljs";
import { styleHeader, autoFitColumns } from "../export/worksheetBuilder";

export const FIELDS_TO_EXCLUDE = new Set([
  "sale_chain_reference",
  "cash_in_bank_report",
  "balance_forward_schedule",
  "detail_forward_schedule",
  "productivity_forward_schedule",
  "current_month_schedule",
  "ar_schedule_code",
  "report_group_codes",
]);

export async function downloadFileUploadTemplate({
  schema,
  setupName,
}: {
  schema: JsonSchema;
  setupName: string;
}): Promise<void> {
  const sections = getSchemaSections(schema);
  const fields = sections
    .flatMap((section) => section.sectionValue)
    .filter((fieldKey) => !FIELDS_TO_EXCLUDE.has(fieldKey));
  const headers: string[] = [];
  const dropdownFields: ColumnOption[] = [];

  fields.forEach((fieldKey: string, index: number) => {
    const property = schema.properties?.[fieldKey];
    if (!property?.title) return;
    headers.push(property.title);
    if (Array.isArray(property.enum) && property.enum.length > 0) {
      dropdownFields.push({ colIndex: index + 1, options: property.enum });
    }
  });

  const workbook = new Workbook();
  const worksheet = workbook.addWorksheet(setupName);

  worksheet.addRow(headers);
  styleHeader(worksheet);
  autoFitColumns(worksheet);

  const MAX_ROWS = 1000;
  dropdownFields.forEach(({ colIndex, options }) => {
    for (let row = 2; row <= MAX_ROWS; row++) {
      worksheet.getCell(row, colIndex).dataValidation = {
        type: "list",
        allowBlank: true,
        formulae: [`"${options.join(",")}"`],
        showErrorMessage: true,
      };
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), `${setupName}-RecordUploadTemplate.xlsx`);
}
